const LogLevel = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3
}

class Logger {
  constructor() {
    this.level = this.getLogLevel()
    this.enabled = import.meta.env.VITE_DEBUG_MODE === 'true'
  }

  getLogLevel() {
    const envLevel = import.meta.env.VITE_LOG_LEVEL?.toLowerCase()
    switch (envLevel) {
      case 'error': return LogLevel.ERROR
      case 'warn': return LogLevel.WARN
      case 'info': return LogLevel.INFO
      case 'debug': return LogLevel.DEBUG
      default: return LogLevel.INFO
    }
  }

  shouldLog(level) {
    return this.enabled && level <= this.level
  }

  error(...args) {
    if (this.shouldLog(LogLevel.ERROR) && process.env.NODE_ENV === 'development') {
      console.error('🔴 [ERROR]', ...args)
    }
  }

  warn(...args) {
    if (this.shouldLog(LogLevel.WARN) && process.env.NODE_ENV === 'development') {
      console.warn('🟡 [WARN]', ...args)
    }
  }

  info(...args) {
    if (this.shouldLog(LogLevel.INFO) && process.env.NODE_ENV === 'development') {
      console.info('🔵 [INFO]', ...args)
    }
  }

  debug(...args) {
    if (this.shouldLog(LogLevel.DEBUG) && process.env.NODE_ENV === 'development') {
      console.log('⚪ [DEBUG]', ...args)
    }
  }

  group(label) {
    if (this.enabled && process.env.NODE_ENV === 'development') {
      console.group(label)
    }
  }

  groupEnd() {
    if (this.enabled && process.env.NODE_ENV === 'development') {
      console.groupEnd()
    }
  }

  table(data) {
    if (this.enabled && this.shouldLog(LogLevel.DEBUG) && process.env.NODE_ENV === 'development') {
      console.table(data)
    }
  }

  time(label) {
    if (this.enabled && this.shouldLog(LogLevel.DEBUG) && process.env.NODE_ENV === 'development') {
      console.time(label)
    }
  }

  timeEnd(label) {
    if (this.enabled && this.shouldLog(LogLevel.DEBUG) && process.env.NODE_ENV === 'development') {
      console.timeEnd(label)
    }
  }
}

export const logger = new Logger()
export default logger